import styled from 'styled-components';
import { Flex } from '@my/ui';
import WalletAccountInfo from './WalletAccount';
// import Balance from 'components/Balance';
import { memo, useEffect, useMemo, useState } from 'react';
import SmallNav from '../Nav/SmallNav';
import { menuItemsDefault } from '../config';
import Asset from './Asset';
import { useVault } from 'state/vault/hooks';
import { useWeb3React } from '@web3-react/core';
import { useSafeContractState } from 'state/safeContract/hooks';
import { IChainItemType } from 'lifiConfig/IChainType';
import Process from './Process';
import { useGlobalState } from 'state/global/hooks';
import { CHAINLISTID } from 'lifiConfig/getWalletConfig';
// import ThemeChange from './ThemeChange';

const UserWidget = ({ collapsed }) => {
  const { multiTokenConfig, multiToken, chainList: chainListConfig } = useVault();
  const { processList } = useGlobalState();
  const { account } = useWeb3React();
  const { safeAddress } = useSafeContractState();
  const [chainList, setChainList] = useState<IChainItemType[]>(chainListConfig);
  useEffect(() => {
    const _chainList = CHAINLISTID;
    if (!chainList || !chainList.length || chainList.length !== _chainList.length) {
      const __chain = _chainList.map((vv) => chainListConfig.filter((v) => `${v.id}` === vv)[0]);
      setChainList(__chain);
    }
  }, [chainList, chainListConfig]);
  return useMemo(() => {
    return (
      <User>
        {collapsed ? (
          <SmallNav
            chainList={chainList}
            menuItems={menuItemsDefault}
            safeAddress={safeAddress}
            account={account}
            multiToken={multiToken}
            multiTokenConfig={multiTokenConfig}
            collapsed={collapsed}
          />
        ) : (
          <Flex alignItems="center">
            {/* <ThemeChange /> */}
            <Process processList={processList} account={account} />
            <Asset
              chainList={chainList}
              safeAddress={safeAddress}
              account={account}
              multiToken={multiToken}
              multiTokenConfig={multiTokenConfig}
              collapsed={false}
            />

            <WalletAccountInfo />
          </Flex>
        )}
      </User>
    );
  }, [collapsed, account, multiToken, multiTokenConfig, safeAddress, chainList, processList]);
};
const User = styled(Flex)`
  flex-direction: column;
  align-items: end;
`;

export default memo(UserWidget);
